import { useHistory } from 'react-router-dom';
import Exit from "../../components/Button/Exit/Exit";
import CobrancasCrud from "../../components/Crud/MainCrud/CobrancasCrud/CobrancasCrud";
import MenuBar from "../../components/Menu/MenuBar";
import Title from "../../components/Title/Title";
import { hasPermission } from "../../utils/utils";
import "./Cobrancas.css";

export default function Cobrancas() {

    const history = useHistory();
    
    if(!hasPermission('cobrancas')){
        history.push('/');
    }
    
    return (
        <div className='Cobrancas'>
            <MenuBar />
            <Title>Cobranças</Title>
            <div className="Container">
                <div className="Content">
                    <div className="row">
                        <CobrancasCrud />
                    </div>
                    <div className="Row-exit">
                        <Exit />
                    </div>
                </div>
            </div>
        </div>
    )
};